import { render, staticRenderFns } from "./VoidImage.vue?vue&type=template&id=0425110e&scoped=true&"
import script from "./VoidImage.vue?vue&type=script&lang=ts&"
export * from "./VoidImage.vue?vue&type=script&lang=ts&"
import style0 from "./VoidImage.vue?vue&type=style&index=0&id=0425110e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0425110e",
  null
  
)

export default component.exports